import { render, staticRenderFns } from "./ExceptionReminder.vue?vue&type=template&id=742e03b0&scoped=true&"
import script from "./ExceptionReminder.vue?vue&type=script&lang=js&"
export * from "./ExceptionReminder.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionReminder.vue?vue&type=style&index=0&id=742e03b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742e03b0",
  null
  
)

export default component.exports